import { GridColDef } from "@mui/x-data-grid";
import CityDetailButton from "./DetailButton";
import CheckCell from "../components/datagrid/CheckCell";

export const assignmentPeriodsColumns: GridColDef[] = [
  {
    field: "",
    renderCell: CityDetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "assignmentPeriodCode",
    minWidth: 150,
    headerName: "Kod",
    sortable: false,
    filterable: false,
  },
  {
    field: "year",
    headerName: "Yıl",
    flex: 1,
    minWidth: 80,
    type: "number",
  },
  {
    field: "period",
    headerName: "Dönem",
    flex: 1,
    minWidth: 80,
    type: "number",
  },
  {
    field: "startDate",
    headerName: "Başlangıç Tarihi",
    flex: 1,
    minWidth: 80,
    type: "date",
    valueGetter: (v, r) => new Date(v),
  },
  {
    field: "endDate",
    headerName: "Bitiş Tarihi",
    flex: 1,
    type: "date",
    valueGetter: (v, r) => new Date(v),
  },
  {
    field: "description",
    headerName: "Tanım",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "isActive",
    headerName: "Aktif",
    flex: 1,
    minWidth: 80,
    renderCell: CheckCell,
    type: "boolean",
  },
];
